export const REVISION_ENTITY_TYPE = {
    SAMPLE: 'SAMPLE',
    PORTION: 'PORTION',
    SUBPORTION: 'SUBPORTION'
}
